import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Box, Grid, useMediaQuery } from "@mui/material";
import { CartoonCardAvatar } from "components/CartoonCard";
import MKPagination from "components/MKPagination";
import SectionDivider from "pages/Presentation/sections/SectionDivider";
import { useEffect, useState } from "react";


function Submissions({ id, submissions, isChampionshipCompleted, onSubmitVote }) {
  // const duplicatedSubmissions = [...submissions, ...submissions, ...submissions, ...submissions, ...submissions, ...submissions];


  const sm = useMediaQuery((theme) => theme.breakpoints.down("sm")); // 1 per row
  const md = useMediaQuery((theme) => theme.breakpoints.between("sm", "md")); // 2 per row
  const lg = useMediaQuery((theme) => theme.breakpoints.between("md", "lg")); // 3 per row
  const xl = useMediaQuery((theme) => theme.breakpoints.up("lg")); // 4 per row

  const [itemsPerPage, setItemsPerPage] = useState(16);

  useEffect(() => {
    if (sm) setItemsPerPage(6);
    else if (md) setItemsPerPage(8);
    else if (lg) setItemsPerPage(12);
    else if (xl) setItemsPerPage(16);
  }, [sm, md, lg, xl]);
  const totalPages = Math.ceil(submissions.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const currentFarts = submissions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <Box id={id} py={10} sx={{ mt: 0, mb: 6, px: 2 }}>
      <SectionDivider title="🧻 All Submissions" />
      <Grid container spacing={2.5}>
        {currentFarts
          // .slice(currentPage * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE + ITEMS_PER_PAGE)
          .map((fart, index) => (
            <Grid key={index} item xs={12} sm={6} md={3}>
              <CartoonCardAvatar
                name={fart.name}
                role=""
                description={fart.description}
                avatar={fart.img_path}
                backgroundColor={fart.bg_color}
                tilt
                baseTileAngle={0}
                endTiltAngle={-3}
                rank={fart.rank}
                votes={fart.voteCount}
                score={fart.score}
                isSmall
                onVote={() => onSubmitVote(fart)}
                onPlay={() => {
                  const audio = new Audio(fart.audio_path);
                  audio.play();
                }}
                onShare={() => console.log("🔗 shared")}
                disabledActions={{ vote: isChampionshipCompleted }}
                sx={{ p: 2, width: "100%", minWidth: 250 }}
              />
            </Grid>
          ))}
      </Grid>

      {totalPages > 1 && (
        <Grid container justifyContent="center" mt={4}>
          <MKPagination placement="center">
            <MKPagination item onClick={() => handlePageChange(currentPage - 1)}>
              <ArrowBackIos fontSize="small" />
            </MKPagination>

            {Array.from({ length: totalPages }, (_, i) => (
              <MKPagination
                key={i + 1}
                item
                active={currentPage === i + 1}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </MKPagination>
            ))}

            <MKPagination item onClick={() => handlePageChange(currentPage + 1)}>
              <ArrowForwardIos fontSize="small" />
            </MKPagination>
          </MKPagination>
        </Grid>
      )}
    </Box>
  );
}

export default Submissions;
